import React from 'react';
import PropTypes from 'prop-types';

import PaginatorBlock from 'components/PaginatorBlock';

import css from './DocumentFilterListBlock.module.scss';
import debounce from 'lodash/debounce';
import cn from 'classnames';

import Button from 'components/Button';
import DropdownFilter from 'components/DropdownFilter';
import TableBlock from 'components/TableBlock';

const DEBOUNCE_DURATION = 500;

class DocumentFilterListBlock extends React.Component {
    static propTypes = {
        apiUrl: PropTypes.string.isRequired, 
        heading: PropTypes.string,
        years: PropTypes.arrayOf(PropTypes.shape({
            key: PropTypes.oneOfType([PropTypes.string,PropTypes.number]),
            value: PropTypes.string
        })), 
        yearsHeading: PropTypes.string,
        divisions: PropTypes.arrayOf(PropTypes.shape({
            key: PropTypes.oneOfType([PropTypes.string,PropTypes.number]),
            value: PropTypes.string
        })), 
        typeHeading: PropTypes.string,
        availableTypes: PropTypes.object,

        filterHeading: PropTypes.string,

        defaultPageSize: PropTypes.number.isRequired,
        documents: PropTypes.shape({
            items: PropTypes.array,
            totalCount: PropTypes.number
        }),
        language: PropTypes.string,
        anchorId: PropTypes.string,
        blockId: PropTypes.number,
        contentType: PropTypes.string,
        pagerLabels: PropTypes.shape({
            prevButton: PropTypes.string,
            nextButton: PropTypes.string,
        }),
    }

    static defaultProps = {
        language: 'no'
    }

    state = {
        year: "",
        type: "",
        page: 1
    }

    constructor(props){
        super();
        this.types = Object.keys(props.availableTypes).map((o) => {
            return {
                "key": o,
                "value": props.availableTypes[o]
            };
        });
        this.state = {
            ...this.state,
            documents: props.documents,
            pageSize: props.defaultPageSize
        };
    }
    pageChange = (page) => {
        this.setState({
            page: page
        }, this._debouncedFilterItems);
    }
    _yearFilter = (e, value) => {
        this.setState({
            page: 1, // reset page
            year: value
        }, this._debouncedFilterItems);
    }
    _typeFilter = (e, value) => {
        this.setState({
            page: 1, // reset page
            type: value
        }, this._debouncedFilterItems);
    }

    _filterItems = () => {
        const filter = { ...this.state };
        delete filter.documents;

        function search() {
            const finalUrl = this.props.apiUrl + "?" + Object.keys(filter).map((item) => item+"="+filter[item]).join("&");
            window.fetch(finalUrl, {
                headers: {
                    'Accept': 'application/json',
                    'Content-Type': 'application/json'
                },
                credentials: 'same-origin',
                method: 'GET'
            })
                .then(res => {
                    if (!res.ok) {
                        this.setState({
                            searching: false,
                        });

                        return console.error(res);
                    }

                    res.json().then(json => {
                        this.setState({
                            documents: json,
                            searching: false,
                        });
                    });
                })
                .catch(err => {
                    console.error(err);

                    this.setState({
                        searching: false,
                    });
                });
        }

        this.setState({
            searching: true,
        }, search);
    }

    _debouncedFilterItems = debounce(this._filterItems, DEBOUNCE_DURATION)

    render() {
        const {
            anchorId,
            yearsHeading,
            years,
            typeHeading,
            filterHeading,
            pagerLabels,
            heading
        } = this.props;
        
        const {
            documents,
            page,
            pageSize
        } = this.state;

        const pageCount = Math.ceil(documents.totalCount / pageSize);

        return (
            <div className={css.block} id={anchorId}>
                {heading && <h2 className={css.blockHeading}>{heading}</h2>}
                <div className={css.filters}>
                    <ul>
                        <li>
                            <DropdownFilter 
                                className={css.filter}
                                heading={yearsHeading} 
                                items={years} 
                                onSelect={this._yearFilter} 
                            />
                        </li>
                        <li>
                            <DropdownFilter
                                className={css.filter}
                                heading={typeHeading} 
                                items={this.types} 
                                onSelect={this._typeFilter} 
                            />
                        </li>
                        <li>
                            <Button secondary compact onClick={this._debouncedFilterItems}>{filterHeading}</Button>
                        </li>
                    </ul>
                </div>
                <div className={css["list-outer"]}>
                    <div className={cn(css.list, {
                        [css.searching]: this.state.searching
                    })}>
                        <TableBlock data={documents.items.map((item, index) => {
                            if(index === 0){
                                return item;
                            }
                            return {
                                ...item,
                                "title": item.link ? "<a href="+item.link+" target='_blank'>"+item.title+"</a>" : item.title
                            };
                        })} keys={["publishedDate", "title"]}/>
                    </div>
                    <PaginatorBlock 
                        pages={pageCount} 
                        currentPage={page} 
                        onPageChange={this.pageChange}
                        prevButtonLabel={pagerLabels && pagerLabels.prevButton ? pagerLabels.prevButton : null}
                        nextButtonLabel={pagerLabels && pagerLabels.nextButton ? pagerLabels.nextButton : null}
                    />
                </div>
            </div>
        );
    }
}

export default DocumentFilterListBlock;



// WEBPACK FOOTER //
// ./src/components/DocumentFilterListBlock/DocumentFilterListBlock.jsx